import React, { FC } from 'react';
import styled from 'styled-components/native';

import { IDemoAccountResponse } from '@webtrader/core/api/experienceDemo';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useTranslation } from '@webtrader/core/i18n';
import { authService } from '@webtrader/core/services/auth';

import Text from '@/components/Text';
import { ALL_MOBILE_ROUTES, replace, useExperienceDemoCreationRouteParams } from '@/utils/navigation';

import NavigationHeader from '../../Header';
import ExperienceDemoCreationForm from './Form';

const ExperienceDemoCreationScreen: FC = () => {
  const { t } = useTranslation();
  const params = useExperienceDemoCreationRouteParams();
  const { setNeedUpdateFields } = params || {};

  const onSuccess = (result: IDemoAccountResponse) => {
    authService.resetloginErrorCode();
    replace(ALL_MOBILE_ROUTES.AUTH.EXPERIENCE_DEMO_COMPLETION, {
      title: t('Your previous account has expired.'),
      subTitle: t('We’ve set up a new demo account for you.'),
      accountDetails: result,
      setNeedUpdateFields
    });
  };

  return (
    <Container>
      <Screen>
        <NavigationHeader title={t('Experience Now!')} />
      </Screen>
      <StyledScrollView>
        <HeaderDescription>
          {t('Gain instant demo access with your email, and receive login details in your inbox.')}
        </HeaderDescription>
        <StyledFormContainer>
          <ExperienceDemoCreationForm onSuccess={onSuccess} />
        </StyledFormContainer>
      </StyledScrollView>
    </Container>
  );
};

export default ExperienceDemoCreationScreen;

const StyledScrollView = styled.ScrollView`
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

const Container = styled.View`
  flex: 1;
`;

const Screen = styled.View`
  padding-start: ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-end: ${({ theme }) => theme.sizes.mobile.basePaddingEnd}px;
`;

const HeaderDescription = styled(Text)`
  padding: ${dynamicSize.convertSize(16)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
  padding-top: ${dynamicSize.convertSize(4)}px;
  color: ${({ theme }) => theme.colors.text[1]};
  font-size: ${dynamicSize.convertSize(15)}px;
  line-height: ${dynamicSize.convertSize(22)}px;
`;

const StyledFormContainer = styled.View`
  padding: ${dynamicSize.convertSize(12)}px ${({ theme }) => theme.sizes.mobile.basePaddingStart}px;
`;
